// @core/api/endpoints/audittrail/list_retention_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListRetentionPoliciesResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List retention policies
 * Returns all retention policies configured for the platform. Supports filtering by active status and compliance framework.
 */
export async function ListRetentionPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListRetentionPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/retention-policies`;
  const requestOptions = options;
  return client.get<ListRetentionPoliciesResponse>(requestPath, { ...requestOptions, params });
}
